/**
 * Created by Ivo Mehide <ivo@degeetia.ee> on 30.10.17.
 */
import _ from "underscore";

class BaseValidator {
    constructor(props, schema) {
        this.props = props;
        this.schema = schema;
    }

    /**
     *
     * @param {Object} value
     * @returns {Object} Return errors in the form: {fieldName: errorMessage} or just errorMessage for main object error
     */
    validate(value) {
        return null;
    }
}

export default BaseValidator;
